import useApi from '../../../../components/js/Composables/useApi'
import type { DocumentType } from '../../../../Types/document'

export function useContractDocumentTypes() {
  const { getJSON, postJSON } = useApi()

  async function getAvailableDocumentType(contractId: number): Promise<DocumentType[]> {
    return await getJSON(`contracts/${contractId}/signable-and-generable-document-types`)
  }

  async function generateDocumentAndAddToSign(documentSignId: number, documentTypeId: number): Promise<void> {
    return await postJSON(`document-signs/${documentSignId}/documents/${documentTypeId}`)
  }

  return {
    // Methods
    getAvailableDocumentType,
    generateDocumentAndAddToSign,
  }
}
